<template>
  <div class="blocoChatBot flex flex-col bg-white shadow-lg">
    <div class="identificadorTopo rounded-t-lg w-full p-3">
      <div class="flex gap-3 w-full text-white">
        <div><vs-avatar /></div>
        <div class="flex justify-between items-center w-full">
          <div>
            <div><span>Risério - Bem Protege</span></div>
            <div><span>Online agora</span></div>
          </div>
          <div class="cursor-pointer">
            <img src="../../assets/images/svg/icon-close-rounded.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="corpoConversa flex flex-col overflow-auto p-3"
      ref="corpoDaConversa"
    >
      <div v-if="aceitaTermos">
        <div class="flex pt-5">
          <div class="pr-3"><vs-avatar /></div>
          <div>
            <div class="msgBot text-black rounded-r-lg rounded-bl-lg p-5">
              <span>Ótimo, vamos começar!</span>
            </div>
            <div class="msgBot text-black rounded-r-lg rounded-bl-lg p-5 mt-5">
              <span>Qual o seu nome e sobrenome?</span>
            </div>
          </div>
        </div>
        <div>
          <div
            class="pb-5"
            v-for="mensagem in mensagensChat"
            :key="mensagem.id"
          >
            <div v-if="mensagem.pergunta" class="flex">
              <div class="pr-3"><vs-avatar /></div>
              <div>
                <div class="msgBot rounded-r-lg rounded-bl-lg">
                  <div
                    class="msgBot text-black rounded-r-lg rounded-bl-lg p-5 mt-5"
                  >
                    <span>{{ mensagem.pergunta }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="flex justify-end">
              <div class="msgUsuario text-white rounded-br-lg rounded-l-lg p-5">
                <div>
                  <span>{{ mensagem.msgUser }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="aguardandoMensagem" class="flex py-5">
          <div class="pr-3"><vs-avatar /></div>
          <div>
            <div class="msgBot rounded-r-lg rounded-bl-lg p-5">
              <div>
                <img
                  src="../../assets/images/svg/loading-blobs.svg"
                  alt="Digitando."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!aceitaTermos" class="flex flex-col items-start">
        <div class="flex justify-start">
          <div class="pr-3"><vs-avatar /></div>
          <div class="flex flex-col items-start">
            <div class="msgBot text-black rounded-r-lg rounded-bl-lg p-5 mb-5">
              <span>Olá, tudo bem?</span>
            </div>
            <div class="msgBot text-black rounded-r-lg rounded-bl-lg p-5 mb-5">
              <span
                >Tenha em mãos o documento do veículo, para realizar a
                contratação da proteção.</span
              >
            </div>
          </div>
        </div>
        <div
          class="botaoComecar flex text-white gap-3 rounded-full cursor-pointer p-5 ml-5"
          @click="aceitaTermos = true"
        >
          <div><span>OK, começar agora</span></div>
          <div class="flex items-center">
            <img
              src="../../assets/images/svg/icon-arrow-right-white.svg"
              alt="Botão send."
            />
          </div>
        </div>
        <div class="pl-5">
          <div class="text-black">
            <span>Clicando em começar você aceita nossas</span>
          </div>
          <div class="text-blue">
            <a href="#"><span>Políticas de Privacidade.</span></a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="boxInputEnvio flex justify-between items-center gap-2 w-full p-2 rounded-b-lg"
    >
      <div class="w-full">
        <vs-input
          class="w-full"
          v-model="mensagemCliente"
          name="mensagemCliente"
          size="large"
        />
      </div>
      <div>
        <div class="cursor-pointer flex items-center" @click="chatBotFlow()">
          <img
            src="../../assets/images/svg/icon-send-blob.svg"
            alt="Botão send."
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from '../../services';

export default {
  data() {
    return {
      mensagemCliente: null,
      aceitaTermos: false,
      aguardandoMensagem: false,
      mensagensChat: [],
      validacaoPorPergunta: {
        email: this.validaEmail,
        celular: this.validaCelular,
        cep: this.validaCep,
        placa: this.buscaPlacaFipe,
      },
      arrPerguntasBot: [
        {
          idPergunta: 'email',
          pergunta: 'Qual seu melhor e-mail?',
          perguntaFeita: false,
        },
        {
          idPergunta: 'celular',
          pergunta: 'Qual seu número de celular para contato?',
          perguntaFeita: false,
        },
        {
          idPergunta: 'cep',
          pergunta: 'Qual seu CEP?',
          perguntaFeita: false,
        },
        {
          idPergunta: 'placa',
          pergunta: 'Qual a placa do veículo',
          perguntaFeita: false,
        },
        {
          idPergunta: 'opcionais',
          pergunta: 'Dê um up em sua proteção, inclua opcionais:',
          perguntaFeita: false,
        },
      ],
      form: {},
    };
  },
  methods: {
    atribuiNovaPropriedade(nomePropriedade) {
      const msg = this.mensagemCliente;
      this.form[nomePropriedade] = msg;
    },
    proximaPergunta(arrayDePerguntas) {
      const perguntaPorFazer = arrayDePerguntas.find(
        (pergunta) => !pergunta.perguntaFeita,
      );
      if (perguntaPorFazer) {
        return perguntaPorFazer;
      } else {
        return false;
      } // Todas as propriedades estão presentes no objeto
    },
    trocaFlagPergunta(idPergunta) {
      this.arrPerguntasBot.forEach((pergunta) => {
        pergunta.idPergunta == idPergunta
          ? (pergunta.perguntaFeita = true)
          : '';
      });
    },
    roladaParaBaixo() {
      const divComOverflow = this.$refs.corpoDaConversa;
      if (divComOverflow) {
        setTimeout(() => {
          const scrollDestino =
            divComOverflow.scrollHeight - divComOverflow.clientHeight;
          const OpcoesDoScroll = {
            top: scrollDestino,
            behavior: 'smooth',
          };
          divComOverflow.scrollTo(OpcoesDoScroll);
        }, 100);
      }
    },
    validaNome(mensagem) {
      mensagem = mensagem.trim();
      return mensagem.length >= 6 ? true : false;
    },
    validaEmail(mensagem) {
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return regexEmail.test(mensagem);
    },

    isCelularValido(telefone) {
      telefone = telefone.replace(/\D/g, '');
      if (!(telefone.length >= 10 && telefone.length <= 11)) {
        return false;
      }

      if (telefone.length === 11 && telefone[2] !== '9') {
        return false;
      }

      if (this.hasDigitosRepetidos(telefone)) {
        return false;
      }

      const codigosDDD = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
      ];

      if (!codigosDDD.includes(parseInt(telefone.substring(0, 2)))) {
        return false;
      }

      if (
        telefone.length === 10 &&
        ![2, 3, 4, 5, 7].includes(parseInt(telefone.substring(2, 3)))
      ) {
        return false;
      }

      return true;
    },
    hasDigitosRepetidos(telefone) {
      for (let n = 0; n < 10; n++) {
        if (telefone === Array(11).join(n) || telefone === Array(12).join(n)) {
          return true;
        }
      }
      return false;
    },
    validaCelular(telefone) {
      if (!this.isCelularValido(telefone)) {
        // Adicione notificações ou tratamento de erro aqui, se necessário.
        return false;
      } else {
        return true;
      }
    },
    async validaCep(mensagem) {
      const cepbusca = mensagem.replace('.', '').replace('-', '');
      try {
        const res = await service.post('g', 'BuscaCEP', {
          cep: cepbusca,
        });
        this.form = {
          ...this.form,
          endereco: res.data.street,
          bairro: res.data.neighborhood,
          cidade: res.data.city,
          estado: res.data.state,
        };
        return true;
      } catch (e) {
        return false;
      }
    },
    async buscaPlacaFipe(placa) {
      try {
        if (placa.length === 8) {
          const res = await service.post('CotacaoAberta', 'BuscaDadosPlaca', {
            placa,
          });

          let dadosPlaca = {};
          if (res.status === 204 && res.data === '') {
            return false;
          } else if (res.data) {
            console.log(2810, res.data);
            dadosPlaca = res.data;
            this.mensagensChat.push({
              pergunta: `Ótimo! Notamos que é um: ${dadosPlaca.marcaModelo} - ${dadosPlaca.ano}/${dadosPlaca.anoModelo} - ${dadosPlaca.situacao}.`,
            });
            return true;
          } else {
            this.dadosPlaca = {};
            this.habilitaAlterarGrupo = false;
          }
        }
      } catch (error) {
        this.habilitaAlterarGrupo = false;
        this.modelosFipeEncontrados = [];
      }
    },
    async chatBotFlow() {
      const arrPerguntas = this.arrPerguntasBot;
      if (this.mensagemCliente) {
        const msg = this.mensagemCliente.trim();
        this.mensagensChat.push({ msgUser: msg });
        if (!this.form.nome) {
          const nomeValidado = this.validaNome(msg);
          if (nomeValidado) {
            this.form = {
              ...this.form,
              nome: msg,
            };
            this.mensagemCliente = null;
          } else {
            this.mensagensChat.push({
              pergunta: `Nome inválido, lembre-se de informar nome e sobrenome.`,
            });
            this.mensagemCliente = null;
            this.roladaParaBaixo();
            return;
          }
        } else {
          const perguntaRespondida = this.proximaPergunta(arrPerguntas);
          if (perguntaRespondida) {
            const funcaoValidacao =
              this.validacaoPorPergunta[perguntaRespondida.idPergunta];
            if (funcaoValidacao) {
              const respostaValida = await funcaoValidacao(msg);
              console.log(316, respostaValida);
              if (respostaValida) {
                this.form = {
                  ...this.form,
                  [perguntaRespondida.idPergunta]: msg,
                };
              } else {
                this.mensagensChat.push({
                  pergunta: `${perguntaRespondida.idPergunta} inválido.`,
                });
                this.mensagemCliente = null;
                this.roladaParaBaixo();
                return;
              }
            }
          }
          this.trocaFlagPergunta(perguntaRespondida.idPergunta);
          this.mensagemCliente = null;
        }
      }
      const proximaPergunta = this.proximaPergunta(arrPerguntas);
      if (proximaPergunta) {
        this.mensagensChat.push(proximaPergunta);
        this.roladaParaBaixo();
      } else {
        console.log(189, 'fim Chat', this.form);
        this.roladaParaBaixo();
      }
    },
  },
  created() {},
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

.blocoChatBot {
  font-family: Roboto;
  min-height: 100vh;
}
.identificadorTopo {
  background: #078fcf;
}
.corpoConversa {
  background: #efefef;
  min-height: 35vh;
  max-height: 35vh;
}
.msgBot {
  background: #ffffff;
}
.msgUsuario {
  background: #078fcf;
}
.botaoComecar {
  background: #078fcf;
}
.boxInputEnvio {
  background: #e0e0e0;
}
.vs-con-input .vs-inputx {
  border: none !important;
}
.vs-input-primary .vs-input--input:focus {
  border: none !important;
  box-shadow: none !important;
}
.footerChatBot {
  flex-shrink: 0;
}
@media (min-width: 992px) {
  .corpoConversa {
    background: #efefef;
    min-width: 40vh;
    max-width: 40vh;
  }
  .identificadorTopo {
    min-width: 40vh;
    max-width: 40vh;
  }
  .boxInputEnvio {
    min-width: 40vh;
    max-width: 40vh;
  }
}
</style>
